import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
// import { GA } from '../../constants'
// import { setWindowGA } from '../../helpers/DTM'
import awardLogo from '../../asset/award.png'
import {
	Main,
	MaxWidth,
	WinnerContent,
	WinnerText,
	TimeLine,
	WinnerDetails,
	WinnerLocation,
	WinnerName,
	WinnerWrapper,
	AwardImage,
} from './styles'
import { LenskartLogo, LogoWrapper } from '../Offers/style'
import { GA } from '../../constants'
import { setWindowGA } from '../../helpers/DTM'
import { currentMonth } from '../../helpers/DateTime'

const Winners = () => {
	const metaData = useSelector((state: RootState) => state.meta)
	const userData = useSelector((state: RootState) => state.user)
	const data = useSelector((state: RootState) => state.offers)

	const { LENSKART_LOGO } = data

	useEffect(() => {
		if (userData?.phone) {
			sendGA()
			sendCT
		}
	}, [userData])

	const sendGA = () => {
		const data = {
			event: GA.eventName,
			pageName: GA.winnersPage,
			mobile: btoa(userData.phone.toString()),
			pageURL: window.location.href + '/winners',
			customerID: userData.id,
			lkUserType: userData.hasPlacedOrder ? 'lkRepeat' : 'lkNew',
			loginStatus: metaData.isLogin,
			platform: metaData.platform,
		}
		setWindowGA(data)
	}

	const sendCT = () => {
		window.clevertap.event.push('Pages Viewed', {
			'Page Name': GA.winnersPage,
			Phone: userData.phone,
		})
	}

	const getTimeLine = () => {
		if (userData.startDateTime) {
			const start = new Date(userData.startDateTime)
			const startMonth = currentMonth(start.getMonth())
			const startDay = start.getDate()
			const end = new Date(userData.endDateTime)
			const endMonth = currentMonth(end.getMonth())
			const endDay = end.getDate()
			return startDay + ' ' + startMonth + ' - ' + endDay + ' ' + endMonth
		}
	}
	return (
		<>
			<MaxWidth>
				<Main>
					<WinnerText>WINNERS</WinnerText>
					<TimeLine>{getTimeLine()}</TimeLine>

					<WinnerContent>
						{userData.winnerList.map((item: any, index: number) => {
							return (
								<WinnerWrapper key={index}>
									<AwardImage src={awardLogo} />
									<WinnerDetails>
										<WinnerName>{item.fullName}</WinnerName>
										<WinnerLocation>{item.address}</WinnerLocation>
									</WinnerDetails>
									<AwardImage src={awardLogo} />
								</WinnerWrapper>
							)
						})}
					</WinnerContent>
					<LogoWrapper>
						<div style={{ width: '50%', marginRight: '20px' }}>
							<LenskartLogo src={LENSKART_LOGO} />
						</div>
					</LogoWrapper>
				</Main>
			</MaxWidth>
		</>
	)
}

export default Winners
